const { useState } = require("react");
const { default: Api, apiPaths } = require("../services/api");

export default function useExistingUser() {

  const [user, setUser] = useState(undefined);

  const onChange = async (data) => {
    if ((data && data.mobile_number && data.mobile_number.length === 11)
      && (!user || (user && user.mobile_number !== data.mobile_number))) {
      const user = (await Api
        .list(apiPaths.USERS + '/all', {
          mobile_number: data.mobile_number
        })).data[0]
      if (user) {
        setUser({
          mobile_number: user.mobile_number,
          city: user.city,
          birth_date: user.birth_date,
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          gender: user.gender,
          profile_pic: user.profile_pic,
          eng_first_name: user.eng_first_name,
          eng_last_name: user.eng_last_name,
          national_card_pic: user.national_card_pic,
        })
      } else {
        // setDefaultValues({})
      }
    }
  }

  return [user, onChange]
}